import { fetchApi } from "./api"
import { mockAlfredClientService } from "@/mocks/mock-service"
import type { AlfredClientConfig, CreateAlfredClientRequest, UpdateAlfredClientRequest } from "@/types/alfred-client"

const USE_MOCKS = import.meta.env.VITE_USE_MOCKS === "true"

const realAlfredClientService = {
  async getAll(): Promise<AlfredClientConfig[]> {
    return fetchApi<AlfredClientConfig[]>("/api/v1/config/alfred/clients")
  },

  async getById(id: number): Promise<AlfredClientConfig> {
    return fetchApi<AlfredClientConfig>(`/api/v1/config/alfred/clients/${id}`)
  },

  async create(data: CreateAlfredClientRequest): Promise<AlfredClientConfig> {
    return fetchApi<AlfredClientConfig>("/api/v1/config/alfred/clients", {
      method: "POST",
      body: JSON.stringify(data),
    })
  },

  async update(id: number, data: UpdateAlfredClientRequest): Promise<AlfredClientConfig> {
    return fetchApi<AlfredClientConfig>(`/api/v1/config/alfred/clients/${id}`, {
      method: "PUT",
      body: JSON.stringify(data),
    })
  },

  async delete(id: number): Promise<void> {
    return fetchApi<void>(`/api/v1/config/alfred/clients/${id}`, {
      method: "DELETE",
    })
  },
}

export const alfredClientService = USE_MOCKS ? mockAlfredClientService : realAlfredClientService

if (import.meta.env.DEV) {
  console.log(`🔧 Alfred Client Service: ${USE_MOCKS ? "MOCK MODE" : "API MODE"}`)
}
